import { AppPermission, WebhooksDTO } from "@closerplatform/spinner-openapi";
import { L10n } from "@fidget/common/i18n";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import commonStyles from "../../../containers/settings/settingsEditCommon.css";
import { useAgentServices } from "../../../models/agentServices";
import { ICurrentUserStore } from "../../../models/currentUser/CurrentUserStore";
import { withPermissionFallback } from "../../HOC/withPermissionFallback/withPermissionFallback";
import { SubtitleDescription } from "../subtitleDescription";
import { WebhookField } from "./webhookField";

interface Props {
  currentUserStore?: ICurrentUserStore;
}

const WebhooksSettingsPure = observer((props: Props) => {
  const { spinnerService } = useAgentServices();
  const [threadCreatedHook, setThreadCreatedHook] = useState<string>();
  const [threadClosedHook, setThreadClosedHook] = useState<string>();

  useEffect(() => {
    spinnerService.getWebhooks().then((result) => {
      setThreadClosedHook(result.threadClosedHook);
      setThreadCreatedHook(result.threadCreatedHook);
    });
  }, []);

  const updateHooks = (data: WebhooksDTO) => {
    const body = { threadClosedHook, threadCreatedHook, ...data };
    if (data.threadClosedHook) {
      setThreadClosedHook(data.threadClosedHook);
    }
    if (data.threadCreatedHook) {
      setThreadCreatedHook(data.threadCreatedHook);
    }
    spinnerService.updateWebhooks(body);
  };

  const render = () => {
    return (
      <>
        <div className={commonStyles.title}>
          <L10n id={"settings.webhooks.title"} />
        </div>

        <div className={commonStyles.section}>
          <SubtitleDescription
            subtitle={intl.formatMessage("settings.webhooks.title")}
            description={intl.formatMessage("settings.webhooks.description")}
          />

          <SubtitleDescription
            subtitle={intl.formatMessage("settings.webhooks.event.conversation.created.title")}
            description={intl.formatMessage(
              "settings.webhooks.event.conversation.created.description"
            )}
          />

          <div className={commonStyles.content}>
            <WebhookField
              key={"cr_" + threadCreatedHook}
              initialValue={threadCreatedHook || ""}
              onSubmit={(tck) => updateHooks({ threadCreatedHook: tck })}
            />
          </div>

          <SubtitleDescription
            subtitle={intl.formatMessage("settings.webhooks.event.conversation.closed.title")}
            description={intl.formatMessage(
              "settings.webhooks.event.conversation.closed.description"
            )}
          />

          <div className={commonStyles.content}>
            <WebhookField
              key={"cl_:" + threadClosedHook}
              initialValue={threadClosedHook || ""}
              onSubmit={(tck) => updateHooks({ threadClosedHook: tck })}
            />
          </div>
        </div>
      </>
    );
  };

  return render();
});

export const WebhooksSettings = withPermissionFallback(
  AppPermission.SettingsWebhooks,
  WebhooksSettingsPure
);
